import React from 'react';
import classnames from 'classnames';

import { Scrollbars } from 'react-custom-scrollbars';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

import style from './index.scss';

const NsLinkModal = (props) => {
  const { nsLinkModal, toggleModal } = props;

  const mockData = [
    {
      alert_id: 'ALT00001201',
      top_hit_score: 71,
      name: 'James Pottar',
      type: 'PEP',
      result: 'True',
      date: '19/09/2018'
    },
    {
      alert_id: 'ALT00001202',
      top_hit_score: 23,
      name: 'Jemes Potter',
      type: 'Adverse Media',
      result: 'False',
      date: '11/08/2018'
    },
    {
      alert_id: 'ALT00001203',
      top_hit_score: 36,
      name: 'James Hotter',
      type: 'Sactions',
      result: 'False',
      date: '12/07/2018'
    }
  ];

  return (
    <Modal
      isOpen={nsLinkModal?.isShown}
      toggle={() => {
        toggleModal();
      }}
      size="lg">
      <ModalBody>
        <p style={{ fontSize: '1rem', fontWeight: 600 }}>Past NS Alerts</p>
        <Scrollbars style={{ height: 240 }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div className={style.pastAlertHeader}>
              <div>Id</div>
              <div>Top Hit Score</div>
              <div>Name</div>
              <div>Type</div>
              <div>Result</div>
              <div>Date</div>
            </div>
            {mockData &&
              mockData.map((alert) => (
                <div
                  className={classnames(
                    style.pastAlertBody,
                    alert.result == 'True' ? style.trueAlert : ''
                  )}>
                  <div>{alert['alert_id']}</div>
                  <div>{alert['top_hit_score']}</div>
                  <div>{alert['name']}</div>
                  <div>{alert['type']}</div>
                  <div>{alert['result']}</div>
                  <div>{alert['date']}</div>
                </div>
              ))}
          </div>
        </Scrollbars>
      </ModalBody>
      <ModalFooter>
        <button
          className={style.actionBtn}
          onClick={(e) => {
            toggleModal([]);
          }}>
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default NsLinkModal;
